var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "256.000000pt",
    height: "256.000000pt",
    viewBox: "0 0 256.000000 256.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231 2066 c-17 -20 -17 -1552 0 -1572 17 -21 2081 -21 2098 0 17 20 17 1552 0 1572 -17 21 -2081 21 -2098 0z m1944 -95 c-11 -10 -153 -139 -315 -286 -162 -147 -346 -314 -408 -371 -155 -141 -187 -146 -300 -40 -37 34 -222 203 -412 375 -190 173 -352 320 -360 327 -12 12 124 14 900 14 891 0 914 0 895 -19z m-1529 -346 c184 -168 334 -309 334 -313 0 -4 -153 -160 -340 -347 l-340 -340 0 653 c0 358 3 652 6 652 3 0 156 -137 340 -305z m1614 -347 l0 -653 -340 340 c-187 187 -339 344 -337 350 4 12 659 613 670 614 4 1 7 -293 7 -651z m-1056 -143 c19 -8 54 -15 76 -15 58 0 102 22 174 84 l62 55 344 -344 345 -345 -925 0 -925 0 345 345 344 344 62 -55 c34 -30 78 -61 98 -69z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.1828afc52b029440f8acc425f4da1bda.svg";
export { ForwardRef as ReactComponent };